import React from 'react';

function PagosPropiedad(props) {
    return (
        <div>
            Pagos de la propiedad
        </div>
    );
}

export default PagosPropiedad;